export default __webpack_public_path__ + "static/accessoires.en.cover-7f5a5b82a37a655b1c22545f08407e97.jpg";